// extracted by mini-css-extract-plugin
module.exports = {"title":"reportWallet_title__3j0ms"};